import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';

import { AuthService } from '../../core/services/auth.service';
import { ErrorCode } from '../../core/models/problem-details';
import { ModalService } from '../../services/modal.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrl: './change-password.component.scss'
})
export class ChangePasswordComponent {
  submitting = false;
  submitSuccess = false;
  errorOnSubmit = false;
  breachWarning = false;
  previousPasswordTried?: string;
  errorCodes: string[] = [];
  errorCodesToShow: string[] = [];

  passwordVisibility = {
    currentPassword: false,
    password: false,
    confirmPassword: false
  };

  changeForm = new FormGroup({
    currentPassword: new FormControl('', Validators.required),
    password: new FormControl('', [Validators.required, Validators.pattern('^(?=.*?[A-Z])(?=.*?[0-9]).{8,50}$')]),
    confirmPassword: new FormControl('', Validators.required)
  });

  constructor(private authService: AuthService, private modalService: ModalService) {

     this.changeForm.valueChanges.subscribe(() => {
      if (this.errorOnSubmit) {
        this.errorOnSubmit = false;
        this.errorCodes = [];
        this.errorCodesToShow = [];
      }
    });

  }

  togglePasswordVisibility(id: 'currentPassword' | 'password' | 'confirmPassword') {
    this.passwordVisibility[id] = !this.passwordVisibility[id];
  }

  change() {
    if (this.changeForm.invalid) {
      return;
    }

    const currentPassword = this.changeForm.value.currentPassword;
    const newPassword = this.changeForm.value.password;
    const confirmPassword = this.changeForm.value.confirmPassword;

    if (currentPassword == null || newPassword == null || confirmPassword == null) {
      return;
    }

    this.errorCodes = [];
    this.errorCodesToShow = [];

    if (newPassword !== confirmPassword) {
      this.errorOnSubmit = true;
      this.errorCodesToShow = ['PasswordMismatch'];
      this.errorCodes = ['PasswordMismatch'];
      return;
    }

    // Only proceed to API call if passwords match
    const ignoreWarnings = this.breachWarning && this.previousPasswordTried === newPassword;
    this.previousPasswordTried = newPassword;

    this.submitting = true;
    this.submitSuccess = false;
    this.errorOnSubmit = false;

    this.authService.changePassword(currentPassword, newPassword, ignoreWarnings).subscribe({
      next: () => {
        this.submitting = false;
        this.submitSuccess = true;

        this.changeForm.setValue({ confirmPassword: '', currentPassword: '', password: '' });
        this.changeForm.markAsPristine();
        this.changeForm.markAsUntouched();

        this.modalService.showPasswordChangedSuccessDialog()
          .afterClosed()
          .subscribe(() => this.authService.logOut());
      },
      error: (res: HttpErrorResponse) => {
        const errorCodes = res.error?.errorCodes;
        if (errorCodes != null) {
          this.errorCodes = errorCodes.map((ec: ErrorCode) => ec.code);
          this.errorCodesToShow = this.errorCodes.filter(ec => ec !== 'PasswordRequirements');
        }

        this.submitting = false;
        this.errorOnSubmit = true;

        if (this.errorCodes.find(ec => ec === 'PasswordBreachWarning')) {
          this.breachWarning = true;
        }
      }
    });
  }
}
